import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import request from "../../qnb/api/request"; // export type ApiLoginResponse = BaseResponse<null>;
export function getWishList(_x) { return _getWishList.apply(this, arguments); }
function _getWishList() { _getWishList = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(data) { var resp; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            _context.next = 2;
            return request.post("/api/v1/quotation/getWishList", Object.assign({}, data, { useSubmitTime: true, inlineError: true }));
        case 2:
            resp = _context.sent;
            return _context.abrupt("return", resp.data);
        case 4:
        case "end": return _context.stop();
    }
} }, _callee); })); return _getWishList.apply(this, arguments); }
export function getLowestPremiumInfo(_x2) { return _getLowestPremiumInfo.apply(this, arguments); }
function _getLowestPremiumInfo() { _getLowestPremiumInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(data) { var resp; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
    switch (_context2.prev = _context2.next) {
        case 0:
            _context2.next = 2;
            return request.post("/api/v1/quotation/getLowestPremiumInfo", Object.assign({}, data, { useSubmitTime: true, height: undefined, weight: undefined, inlineError: true }));
        case 2:
            resp = _context2.sent;
            return _context2.abrupt("return", resp.data);
        case 4:
        case "end": return _context2.stop();
    }
} }, _callee2); })); return _getLowestPremiumInfo.apply(this, arguments); }
